<template>
    <div class="story-2">
        <div class="st-2-left-container animated fadeIn 0.5s">
            <div class="chart-container">
                <svg width="40" height="400">
                    <line x1="15" y1="15" x2="15" y2="340" style="stroke:rgba(255,255,255, 0.3);stroke-width:30"
                          stroke-linecap="round"/>
                    <line class="path"
                          :class="{ 'dash-it' : storyIndex >= 1 }" x1="15" y1="15" x2="15" y2="340"
                          style="stroke:#00bfed; stroke-width:15" stroke-linecap="round"/>
                    <line class="path"
                          :class="{ 'step-1' : storyIndex > 1 }" x1="15" y1="15"
                          x2="15" y2="340" style="stroke:#bf520c; stroke-width:15" stroke-linecap="round"/>
                    <line class="path"
                          :class="{ 'step-2' : storyIndex > 1 }"
                          x1="15" y1="15" x2="15" y2="340" style="stroke:#03028b; stroke-width:15"
                          stroke-linecap="round"/>
                    <line class="path"
                          :class="{ 'step-3' : storyIndex > 1 }"
                          x1="15" y1="15" x2="15" y2="340" style="stroke:#19ae34; stroke-width:15"
                          stroke-linecap="round"/>
                </svg>
            </div>
            <div class="chart-indicator">
                <transition enter-active-class="animated fadeIn delay-3s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex >= -1 && storyIndex <= 1" :computed-props="chartIndicators[0]"
                                    :class="{ 'bottom-position' : storyIndex === 1 }"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex > 0" :computed-props="chartIndicators[1]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex > 1" :computed-props="chartIndicators[2]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex > 1" :computed-props="chartIndicators[3]"/>
                </transition>
                <transition enter-active-class="animated fadeIn delay-1s" leave-active-class="animated fadeOut">
                    <ChartIndicator v-if="storyIndex > 1" :computed-props="chartIndicators[4]"/>
                </transition>
            </div>
            <div class="st-image-container animated fadeIn delay-1s">
                <img src="@/assets/img/story_2_images/90.png">
            </div>
        </div>
        <div class="st-2-right-container animated fadeIn">
            <div class="st-2-story">
                <transition enter-active-class="animated fadeIn"
                            leave-class="animated fadeOut">
                    <p v-if="storyIndex > 1">KULLANDIĞIMIZ HER ŞEYİN BİZE GELENE KADAR BİR SU TÜKETİM GEÇMİŞİ VAR</p>
                </transition>

                <div class="st-2-image-container" v-if="this.storyIndex >= 2">
                    <transition enter-active-class="animated fadeIn"
                                leave-active-class="animated fadeOut" mode="out-in">
                        <img :key="storyIndex"
                             :src="require('@/assets/img/story_2_images/' + this.storySections[storyIndex].img)"
                             :class="(this.storySections[storyIndex].img).replace('@3x.png', '')"
                             alt="" v-if="this.storyIndex >= 2"/>
                    </transition>
                </div>

                <transition enter-active-class="animated fadeIn"
                            leave-active-class="animated fadeOut" mode="out-in">
                    <p v-if="storyIndex > -1" :key="storyIndex" v-html="this.storySections[storyIndex].text">
                        {{ this.storySections[storyIndex].text }}
                    </p>
                </transition>
            </div>
            <div class="story-button-container">
                <transition enter-active-class="animated fadeIn delay-5s" leave-active-class="animated fadeOut">
                    <div style="height: 80px; width: 100%; display: flex;" v-if="storyIndex === 4">
                        <div class="next-story">Bölüm 3</div>
                        <ButtonBlueBackground :text="'TÜRKİYE’NİN NE KADAR SUYU VAR?'" :to="'/03'"/>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import ChartIndicator from "../components/ChartIndicator";
    import ButtonBlueBackground from "../components/ButtonBlueBackground";
    import EventBus from "../main";

    export default {
        name: "Story2",
        data() {
            return {
                storySections: {
                    0: {
                        'text': 'Ortalama günde 2 Litre su içiyoruz\n' +
                            'ama gerçekte yaşamımız için gereken \n' +
                            'su tüketimi çok daha fazla', 'img': ''
                    },
                    1: {
                        'text': 'Ortalama günde 2 Litre su içiyoruz\n' +
                            'ama gerçekte yaşamımız için gereken \n' +
                            'su tüketimi çok daha fazla', 'img': ''
                    },
                    2: {
                        'text': 'Bir <strong>hamburger</strong> üretimi için <strong>2.500 lt</strong> su gerekir',
                        'img': 'story_2_hamburger@3x.png'
                    },
                    3: {'text': 'Bir jean pantolon üretimi için 1.000 lt su gerekir', 'img': 'story_2_jeans@3x.png'},
                    4: {
                        'text': 'Bir <strong>çift yumurta</strong> üretimi için <strong>880 lt</strong> su gerekir',
                        'img': 'story_2_egg@3x.png'
                    }
                },
                chartIndicators: {
                    "0": {
                        "container": "top: 5px; right: 120px;",
                        "line": "",
                        "textPos": "top: -15px; width: 120px; left: 45px;",
                        "text": "2 Litre"
                    },
                    "1": {
                        "container": "top: 5px; right: 120px;",
                        "line": "",
                        "textPos": "top: -15px; width: 120px; left: 45px;",
                        "text": "3000 Litre"
                    },
                    "2": {
                        "container": "    top: 105px;     right: 120px;",
                        "line": "",
                        "textPos": "top: -15px; width: 120px; left: 45px;",
                        "text": "Giyim"
                    },
                    "3": {
                        "container": "    top: 215px;     right: 120px;",
                        "line": "",
                        "textPos": "top: -15px; width: 120px; left: 45px;",
                        "text": "Temizlik"
                    },
                    "4": {
                        "container": "    top: 305px;     right: 120px;",
                        "line": "",
                        "textPos": "top: -15px; width: 120px; left: 45px;",
                        "text": "Gıda"
                    }
                },
                storyDone: false,
                storyButton: false,
                storyDuration: 30, /* in seconds */
                storyTime: 0,
                storyIndex: 0,
                storyInterval: null
            }
        },
        watch: {
            storyIndex(value) {
                value === 0 ? setTimeout(() => {
                    EventBus.$emit('show-dune-picture')
                }, 1000) : setTimeout(() => {
                    EventBus.$emit('hide-dune-picture')
                }, 500);
            },
            storyDone(value) {
                value ? EventBus.$emit('story-done', { story: 2, value: true }) : EventBus.$emit('story-done', {story: 2, value: false});
            }
        },
        methods: {
            getImage(img) {
                return require('@/assets/img/story_2_images/' + img);
            },
            startStoryTime() {
                this.storyIndex = -1;
                let storyIndexInterval = (this.storyDuration * 1000) / Object.keys(this.storySections).length;
                this.$store.commit('changeStory', 2);
                this.storyInterval = setInterval(() => {
                    if (this.storyTime >= (this.storyDuration * 1000)) {
                        clearInterval(this.storyTime);
                        this.storyDone = true;
                    } else {
                        Math.floor(this.storyTime % storyIndexInterval) === 0 ? this.storyIndex++ : false;
                        this.storyTime += 100;
                    }
                }, 100)
            }
        },
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'story');
            this.$store.commit('changeStory', 2);
            EventBus.$on('restart-story', () => {
                this.storyTime = 0;
                this.storyDone = false;
                this.startStoryTime();
            })
        },
        created() {
            setTimeout(() => {
                this.startStoryTime();
            }, 3000);
        },
        beforeDestroy() {
            if (!(this.$route.name).includes('Story')) {
                EventBus.$emit('destroy-sequence');
            }
        },
        destroyed() {
            clearInterval(this.storyInterval);
        },
        components: {
            ChartIndicator,
            ButtonBlueBackground
        }
    }
</script>

<style lang="scss">
    .story-2 {
        height: auto;
        min-height: initial !important;
        max-height: 80%;
        position: relative !important;
        top: 0 !important;

        .st-2-left-container {
            margin: auto 15px;
            width: 500px;
            position: relative;
            bottom: 0;
            height: 100%;
            display: flex;
            flex-direction: row-reverse;

            .chart-container {
                width: 35px;
                height: 350px;
                margin-left: auto;
                margin-right: 95px;
                transform: rotateX(180deg);

                .path {
                    stroke-dasharray: 340;
                    stroke-dashoffset: 340;
                    transition: stroke-dashoffset 1s ease-in-out;

                    &.dash-it {
                        stroke-dashoffset: 0;
                    }

                    &.step-1 {
                        stroke-dashoffset: 70;
                    }

                    &.step-2 {
                        stroke-dashoffset: 170;
                    }

                    &.step-3 {
                        stroke-dashoffset: 290;
                    }
                }
            }

            .chart-indicator {
                position: absolute;
                right: 0;
                top: 0;

                .ci-container {
                    transition: top 500ms ease-in;
                    transition-delay: 1s;
                }

                .ci-container.bottom-position {
                    top: 330px !important;
                }

                @media only screen and (max-device-width: 768px) {
                    display: none;
                }
            }

            .st-image-container {
                height: auto;
                min-height: 550px;
                position: relative;
                top: -60px;
                left: 50%;
                transform: translateX(-50%);

                img {
                    -webkit-animation: hover 10s infinite ease-in-out;
                    -o-animation: hover 10s infinite ease-in-out;
                    animation: hover 10s infinite ease-in-out;
                    height: 630px;
                }
            }

            @media only screen and (max-device-width: 768px) {
                max-height: 550px;
            }
        }

        .st-2-right-container {
            height: auto;
            min-height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 490px;
            margin-bottom: auto;

            .st-2-story {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 25px auto auto auto;
                height: 80%;

                .st-2-image-container {
                    width: 140px;
                    height: 140px;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    img {
                        margin: auto;

                        &.story_2_hamburger {
                            width: 100%;
                            height: auto;
                        }

                        &.story_2_jeans {
                            height: 100%;
                            width: auto;
                        }

                        &.story_2_egg {
                            width: 100%;
                            height: auto;
                        }
                    }
                }

                p {
                    width: 482px;
                    height: auto;
                    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.22);
                    font-size: 23px;
                    font-weight: lighter;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    text-align: center;
                    color: #ffffff;

                    strong {
                        font-weight: bolder;
                    }

                    &:nth-of-type(2) {
                        height: 100px;
                    }
                }

                @media only screen and (max-device-width: 768px) {
                    width: 100%;
                    height: initial;
                    & > p {
                        width: 90%;
                        font-size: 36px;
                    }
                }
            }

            .story-button-container {
                margin-top: auto;
                width: 100%;
                height: 80px;
                min-height: 80px;
                margin-bottom: 85px;

                & > div {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                }

                .blue-button {
                    width: 380px;
                    margin: 0 auto;
                    justify-content: center;
                }

                @media only screen and (max-device-width: 768px) {
                    margin-top: 0;

                    .next-story {
                        font-size: 36px;
                    }
                    a.blue-button {
                        width: 670px;
                        min-height: 100px;

                        p {
                            font-size: 30px;
                        }
                    }
                }
            }

            @media only screen and (max-device-width: 768px) {
                width: 100%;
                min-height: 670px;
            }
        }

        @media only screen and (max-width: 1024px) {
            padding-top: 75px;

            .st-2-right-container {
                padding-top: 0;
            }
        }
    }
</style>